import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {AuthGuard} from "./auth-guard.service";
import {Config} from "../config";

@Injectable()
export class ProductService {
  private products;
  constructor(private http: HttpClient ) {}

  private ProductsData() {
    const authToken = AuthGuard.readCookie('AuthToken') || localStorage.getItem('AuthToken');
    const headers = new HttpHeaders({'Authorization': 'JWT ' + authToken});
    const options = { headers };
    const url = Config.BASE_URL + 'products/';
    this.products = this.http.get(url, options);
  }

  getProducts() {
    if (!this.products) {
      this.ProductsData();
    }
    return this.products;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/ProductService.ts